import { AuthScreen } from "../auth/AuthScreen";
import { SystemState } from "../../shared/components/SystemState";
import { useShiftProductionFormWorkspace } from "../shift-production-form/useShiftProductionFormWorkspace";
import { WorkOrderPage } from "./WorkOrderPage";
export function WorkOrderModule() {
  const { session, reload } = useShiftProductionFormWorkspace();
  if (session.phase === "loading") return <SystemState mode="page" tone="loading" title="İş emirleri hazırlanıyor" description="Oturumunuz doğrulanıyor." />;
  if (session.phase === "error") return <AuthScreen mode="service-unavailable" onRetry={reload} />;
  if (!session.actor) return <AuthScreen />;
  if (session.actor.kind !== "CORPORATE") return <SystemState mode="page" tone="warning" title="Kurumsal oturum gerekli" description="İş emri raporu için üretim raporu yetkili kurumsal hesabınızla giriş yapın." />;
  return <WorkOrderPage key={`${session.actor.id}:${session.expiresAt ?? "session"}`} />;
}
